var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { msg, localized } from '@lit/localize';
import '../text/JsonDisplayer';
let JsonDisplayerInput = class JsonDisplayerInput extends LitElement {
    constructor() {
        super(...arguments);
        this.json = '';
        this.data = null;
        this.error = '';
    }
    onInput(e) {
        this.json = e.target.value;
        try {
            this.data = this.json ? JSON.parse(this.json) : null;
            this.error = '';
            this.dispatchEvent(new CustomEvent('json-changed', { detail: this.data }));
        }
        catch (err) {
            this.data = null;
            this.error = msg('Invalid JSON', { id: 'form.json.invalid', desc: 'Invalid JSON error message' });
        }
    }
    render() {
        return html `
      <textarea
        .value=${this.json}
        @input=${this.onInput}
        placeholder=${msg('Paste or write JSON here...', { id: 'form.json.placeholder', desc: 'JSON textarea placeholder' })}
      ></textarea>
      ${this.error ? html `<div class="error">${this.error}</div>` : ''}
      <json-displayer .data=${this.data}></json-displayer>
    `;
    }
};
JsonDisplayerInput.styles = css `
    :host {
      display: block;
    }
    textarea {
      width: 100%;
      min-height: 120px;
      font-family: 'Fira Code', monospace;
      font-size: 1em;
      margin-bottom: 1em;
      box-sizing: border-box;
    }
    .error {
      color: #b71c1c;
      margin-bottom: 0.5em;
    }
  `;
__decorate([
    property({ type: String })
], JsonDisplayerInput.prototype, "json", void 0);
__decorate([
    property({ type: Object })
], JsonDisplayerInput.prototype, "data", void 0);
__decorate([
    property({ type: String })
], JsonDisplayerInput.prototype, "error", void 0);
JsonDisplayerInput = __decorate([
    localized(),
    customElement('json-displayer-input')
], JsonDisplayerInput);
export { JsonDisplayerInput };
//# sourceMappingURL=JsonDisplayerInput.js.map